import { Schedule } from 'types/task';

export const SCHEDULE_OPTIONS = [
  { label: 'Daily', value: Schedule.DAILY },
  { label: 'Weekly', value: Schedule.WEEKLY },
  { label: 'Monthly', value: Schedule.MONTHLY },
  { label: 'Custom time', value: Schedule.CUSTOM_TIME },
];

export const TIMEOUT_OPTIONS = [
  { label: 'Run Now', value: Schedule.NOW },

  // { label: 'Per day', value: Schedule.DAILY },
  { label: 'Per minute', value: Schedule.EVERY_MINUTE },
  { label: 'Per hour', value: Schedule.HOURLY },
];

export const WEEKDAYS = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
];
